export const state = {
    title: null
}

export const mutations = {
    SET_TITLE(state, newValue) {
        state.title = newValue
    }
}

export const getters = {
    getTitle(state) {
        return state.title
    },
}

export const actions = {
    async setTitle({ commit }, value) {
        commit("SET_TITLE", value)
    }
}

